import React from "react";
import Image from "next/image";
import { useTranslation } from "next-i18next";

import TbalerMoodEmpty from "public/images/tabler_mood-empty.svg";

function NoAffariyetPage() {
  const { t: translate } = useTranslation("offers");

  return (
    <div className="flex flex-col gap-3 justify-center items-center w-full h-full m-auto">
      <Image
        src={TbalerMoodEmpty}
        alt={"tabler mood empty icon"}
        width={60}
        height={60}
        className="w-[60px] lg:w-[90px] aspect-square"
      />
      <p className="font-semibold text-lg lg:text-2xl leading-5 text-[#BABABA]">
        {translate("no_affariyet")}
      </p>
      <p className="font-normal text-base lg:text-lg leading-5 text-[#BABABA]">
        {translate("be_the_first")}
      </p>
    </div>
  );
}

export default NoAffariyetPage;
